<template>
    <div class="h-100">
        <ul class="metadata-dock-ul"  style="margin-bottom:0px !important">
            <li v-if="enableMediaSlug && !isTypeCatalog">
                <div class="upload-fields" :class="{focusField:activeField == 'slug'}" v-on:click="activeField = 'slug'">
                    <div class="key-style">{{$t('Media slug')}}</div>
                    <div class="value-style d-inline-flex">
                        <div class="w-100">
                             <input
                              :value="mediaSlug"
                              @change="updateMediaValue($event.target.value)"
                              type="text"
                              :class="{readOnly:nonEditableFields}"
                              class="rounded input-fields text-light w-100"
                              style="margin-inline-start:5px;padding: 4px;"
                              ref="slug_name_field_in_seq_metadata"
                            />
                        </div>
                    </div>
                </div>
            </li>
            
            <li v-if="!globalSettingsFromStartup.configure_description_from_screen && !enableOnlyFields && enableFieldsWithMetadataPriv">
                <div class="upload-fields" :class="{focusField:activeField == 'description'}" v-on:click="activeField = 'description'">
                    <div class="key-style" style="display:flex">
                          <div>{{$t('Description')}}</div>
                          <div v-if="screenType == 'Subclip'" class="dropdown" style="position:relative;top:-5px;">
                              <div
                                  class="nav-item  p-1 dropdown-toggle mr-md-2"
                                  id="bd-versions"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="true"
                                  >
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ababab" class="bi bi-three-dots-vertical context-menu" viewBox="0 0 16 16">
                                  <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                  </svg>
                                  </div>
                                  <div
                                  class="dropdown-menu dropdown-menu-md-right p-0"
                                  aria-labelledby="bd-versions"
                                  >
                                  <a class="dropdown-item p-2" v-on:click.stop.prevent="openParentAssetDescriptionDialog()">
                                      {{$t('Parent asset description')}}</a>
                                  </div>
                      </div></div>
                    <div class="value-style d-inline-flex">
                        <div class="w-100">
                            <textarea :class="{readOnly:nonEditableFields}" type="text" class="border rounded text-light w-100" v-model="description"
                            placeholder="Enter Description" style="margin-inline-start:5px;max-height:200px;min-height: 100px;padding: 4px;"></textarea> 
                        </div>
                    </div>
                </div>
            </li>
            <li v-if="!globalSettingsFromStartup.configure_tags_from_screen && !enableOnlyFields && enableFieldsWithMetadataPriv && (profileDetails.tag_displayall_config > 0||
                                  profileDetails.tag_display_config > 0 ||
                                   selectedRelaventProfileIdList.includes('All'))">
              <div class="upload-fields" :class="{focusField:activeField == 'tags'}" v-on:click="activeField = 'tags'">
                  <div class="key-style d-inline-flex">{{$t('Tags')}}</div>
                  <div class="value-style d-inline-block" style="margin-inline-start:3px;width:97%">
                      <div class="w-100">
                        <tags-dropdown ref="tagsComponent" :selectedTagsList="tagNamesList" :selectedTagIds="getAssetMTagIds()" style="margin-inline-start:2px;"></tags-dropdown>
                      </div>
                  </div>
              </div>
            </li>
            <template v-if="(enableLoadMoreFields && screenType == 'Subclip') || screenType != 'Subclip'">
              <li v-if="(!globalSettingsFromStartup.configure_catalogs_from_screen && (!enableOnlyFields || enableCatalog) && ( parentRouteName != 'bins-browse' || getStartUpDataFromInCache().upload_settings[0].create_catalog_as_bin_path == false))">
                <div class="upload-fields" :class="{focusField:activeField == 'category',readonlyDiv:globalSettingsFromStartup && globalSettingsFromStartup.CATALOG_READ_ONLY}" v-on:click="activeField = 'category'">
                <div class="key-style d-inline-flex">{{$t('Catalogs')}}
                  <span class="readonly-field ml-1" v-if="globalSettingsFromStartup && globalSettingsFromStartup.CATALOG_READ_ONLY">
                    ( non editable )
                  </span>
                </div>
                  <div class="value-style d-inline-block" :style='fixMinWidth?"width:92%":"width:94%"'>
                    <div class="w-100">
                      <multi-catalog-dropdown ref="catalogMultiPicklist2"
                              :allowSingleSelect="!(globalSettingsFromStartup && globalSettingsFromStartup.enable_multi_catalog_browse)"
                              :allowSingleSelectFromBrowse="!(globalSettingsFromStartup && globalSettingsFromStartup.enable_multi_catalog_browse)"
                              from="TagMetadata"
                              :enableCatBrowser="globalSettingsFromStartup && globalSettingsFromStartup.CATALOG_READ_ONLY?false:true"
                              :selectedOptions="selectedCatParentIdPathList"
                              @removedCatalogFromList="removedCatalogFromList"
                              @updatedCatalogsList="updatedCatalogsListComp"
                              :browserPermissions="defaultAssetsBrowseAccess"
                              :class="{readOnly:nonEditableFields}">
                      </multi-catalog-dropdown>
                    </div>
                  </div>
                </div>
              </li>

            <li v-if="!enableOnlyFields && enableFieldsWithMetadataPriv && metadataProfileList.length > 0 &&
               ![undefined,null].includes(relevantProfilesList) && relevantProfilesList.length > 0">
              <div class="upload-fields">
                <div class="key-style">{{$t('Screen Profile')}}</div>
                <div class="value-style d-inline-flex">
                  <div class="w-100">
                    <div class="d-inline-block w-100">
                      <div>
                        <Multiselect
                          v-model="checkedProfiles" 
                          :options="relevantProfilesList"
                          :multiple="true"
                          track-by="metadata_profile_id"
                          :custom-label="screenProfileLabelCallback"
                          :close-on-select="true"
                          :show-no-results="false"
                          deselectLabel =""
                          selectLabel=""
                          selectedLabel=""
                          ref="profiles"
                          placeholder="Enter profile"
                          :hideSelected="false"
                          :showNoOptions="false"
                          @remove="removeProfile($event)"
                          @select="selectProfile($event)"
                          style="margin-inline-start:5px;padding-inline-start:4px">
                          <span slot="noResult">No results</span>
                          <span slot="noOptions" style="display:none"></span>
                          <div slot="tag" slot-scope="option" class="selected-tags-style">
                          <div class="tags-display-style">{{option.option.name}}</div>
                          <div class="remove-tag" v-on:click="removeSelectedOption(option.option)">
                              <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" style="margin-inline-start: 8px;"/>
                              </svg>
                          </div>
                          </div>
                          <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                          <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeProfileCheckBoxSelection(scope.option)" @focus.prevent :key="scope.option.name"/>
                          <span style="margin-inline-start:12px;">{{ scope.option.name }}</span>
                          </div>
                        </Multiselect>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>

              <template v-if="enableFieldsWithMetadataPriv">
                <div v-for="eachId in uploadScreenInfo.field_id_list" :key="eachId">
                  <div v-if="displayAlwaysFieldsIdList.includes(eachId) ||  profileDetails.custom_metadata_allId_list ||
                  (profileDetails.custom_metadata_display_config > 0 && fetchedFieldIdList.includes(eachId)) ||
                    selectedRelaventProfileIdList.includes('All')">
                    <template v-if="eachId == 'Tags'">
                      <li v-if="globalSettingsFromStartup.configure_tags_from_screen && !enableOnlyFields && enableFieldsWithMetadataPriv && (profileDetails.tag_displayall_config > 0||
                                  profileDetails.tag_display_config > 0 ||
                                   selectedRelaventProfileIdList.includes('All'))">
                        <div class="upload-fields" :class="{focusField:activeField == 'tags'}" v-on:click="activeField = 'tags'">
                            <div class="key-style d-inline-flex">{{$t('Tags')}}</div>
                            <div class="value-style d-inline-block" style="margin-inline-start:3px;width:97%">
                                <div class="w-100">
                                  <tags-dropdown ref="tagsComponent" :selectedTagsList="tagNamesList" :selectedTagIds="getAssetMTagIds()" style="margin-inline-start:5px;"></tags-dropdown>
                                </div>
                            </div>
                        </div>
                      </li>
                    </template>
                    <template v-else-if="eachId == 'Catalogs'">
                      <li v-if="globalSettingsFromStartup.configure_catalogs_from_screen && ((!enableOnlyFields || enableCatalog) && ( parentRouteName != 'bins-browse' || getStartUpDataFromInCache().upload_settings[0].create_catalog_as_bin_path == false))">
                        <div class="upload-fields" :class="{focusField:activeField == 'category',readonlyDiv:globalSettingsFromStartup && globalSettingsFromStartup.CATALOG_READ_ONLY}" v-on:click="activeField = 'category'">
                        <div class="key-style d-inline-flex">{{$t('Catalogs')}}
                          <span class="readonly-field ml-1" v-if="globalSettingsFromStartup && globalSettingsFromStartup.CATALOG_READ_ONLY">
                            ( non editable )
                          </span>
                        </div>
                          <div class="value-style d-inline-block" :style='fixMinWidth?"width:92%":"width:94%"'>
                            <div class="w-100">
                              <multi-catalog-dropdown ref="catalogMultiPicklist"
                                      :allowSingleSelect="!(globalSettingsFromStartup && globalSettingsFromStartup.enable_multi_catalog_browse)"
                                      :allowSingleSelectFromBrowse="!(globalSettingsFromStartup && globalSettingsFromStartup.enable_multi_catalog_browse)"
                                      from="TagMetadata"
                                      :enableCatBrowser="globalSettingsFromStartup && globalSettingsFromStartup.CATALOG_READ_ONLY?false:true"
                                      :selectedOptions="selectedCatParentIdPathList"
                                      @removedCatalogFromList="removedCatalogFromList"
                                      @updatedCatalogsList="updatedCatalogsListComp"
                                      :browserPermissions="defaultAssetsBrowseAccess"
                                      :class="{readOnly:nonEditableFields}">
                              </multi-catalog-dropdown>
                            </div>
                          </div>
                        </div>
                      </li>
                    </template>
                    <template v-else-if="eachId == 'Description'">
                      <li v-if="globalSettingsFromStartup.configure_description_from_screen && !enableOnlyFields && enableFieldsWithMetadataPriv">
                        <div class="upload-fields" :class="{focusField:activeField == 'description'}" v-on:click="activeField = 'description'">
                            <div class="key-style" style="display:flex">
                                  <div>{{$t('Description')}}</div>
                                  <div v-if="screenType == 'Subclip'" class="dropdown" style="position:relative;top:-5px;">
                                      <div
                                          class="nav-item  p-1 dropdown-toggle mr-md-2"
                                          id="bd-versions"
                                          data-toggle="dropdown"
                                          aria-haspopup="true"
                                          aria-expanded="true"
                                          >
                                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ababab" class="bi bi-three-dots-vertical context-menu" viewBox="0 0 16 16">
                                          <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                          </svg>
                                      </div>
                                      <div
                                          class="dropdown-menu dropdown-menu-md-right p-0"
                                          aria-labelledby="bd-versions"
                                          >
                                          <a class="dropdown-item p-2" v-on:click.stop.prevent="openParentAssetDescriptionDialog()">
                                              {{$t('Parent asset description')}}</a>
                                      </div>
                                  </div>
                            </div>
                            <div class="value-style d-inline-flex">
                                <div class="w-100">
                                    <textarea :class="{readOnly:nonEditableFields}" type="text" class="border rounded text-light w-100" v-model="description"
                                    style="margin-inline-start:5px;max-height:200px;min-height: 100px;padding: 4px;"></textarea> 
                                </div>
                            </div>
                        </div>
                      </li>
                    </template>
                    <template v-else>
                      <div v-for="custommetadata in (customMetadataList.filter((cmdata)=>(cmdata._id == eachId && (!('parent_field_id_list' in cmdata) || (cmdata['parent_field_id_list'].length == 0)))))" :key="custommetadata._id">
                        <template v-if="!('definition_type' in custommetadata) ||
                          ('definition_type' in custommetadata && custommetadata.definition_type == 'user-defined')">
                          <li :id="'field-'+custommetadata._id" :key="custommetadata._id" class="d-block"
                            >
                            <div style="display: flex;position:relative">
                            <div class="upload-fields" :class="{focusField:activeField == custommetadata.name, 
                            readonlyDiv: uploadScreenInfo.read_only_field_id_list.includes(custommetadata._id)}" v-on:click="activeField = custommetadata.name">
                              <div style="display: flex;justify-content: end;width:20%">
                                <div class="key-style">{{ getCustomMetadataName(custommetadata) }}
                                  <span class="readonly-field" v-if="uploadScreenInfo.read_only_field_id_list.includes(custommetadata._id)">
                                  ( non editable )
                                  </span>
                                </div>
                                <span style="color:#858585" v-if="uploadScreenInfo.mandatory_field_id_list.includes(custommetadata._id)">*</span>
                              </div>
                              <div class="value-style d-inline-flex">
                                <div v-if="uploadScreenInfo.read_only_field_id_list.includes(custommetadata._id)"></div>
                                <div v-else class="w-100">
                                  <input
                                    :value="getCustomMetadataById(custommetadata._id)"
                                    type="text"
                                    :class="{readOnly:nonEditableFields}"
                                    @change="updateCustomMetadataById(custommetadata, $event.target.value)"
                                    v-if="custommetadata.type == 'FREETEXT'"
                                    class="rounded input-fields text-light w-100"
                                    style="margin-inline-start:5px;padding: 4px;"
                                    :id="custommetadata._id"
                                    :placeholder="'Select '+custommetadata.name"
                                  />

                                  <textarea
                                    :value="getCustomMetadataById(custommetadata._id)"
                                    type="text"
                                    :class="{readOnly:nonEditableFields}"
                                    @change="updateCustomMetadataById(custommetadata, $event.target.value)"
                                    v-if="custommetadata.type == 'FREETEXT_MULTILINE'"
                                    class="rounded text-light w-100"
                                    style="margin-inline-start:5px;max-height:200px;min-height: 100px;padding: 4px;
                                    :1px solid #3a3a3a !important;"
                                    :id="custommetadata._id"
                                    :placeholder="'Select '+custommetadata.name"
                                    >
                                  </textarea>
                                  <input
                                    :value="getCustomMetadataById(custommetadata._id)"
                                    type="number"
                                    :class="{readOnly:nonEditableFields}"
                                    @change="updateCustomMetadataById(custommetadata, $event.target.value)"
                                    v-if="custommetadata.type == 'INTEGER'"
                                    class="rounded input-fields text-light w-100"
                                    style="margin-inline-start:5px;padding: 4px;"
                                    :id="custommetadata._id"
                                    :placeholder="'Select '+custommetadata.name"
                                  />
                                  <date-picker
                                    :value="getCustomMetadataById(custommetadata._id)"
                                    v-if="custommetadata.type == 'DATE'"
                                    valueType="format"
                                    :class="{readOnly:nonEditableFields}"
                                    @change="updateCustomMetadataById(custommetadata, $event)"
                                    class="rounded text-light w-100"
                                    style="margin-inline-start:5px;"
                                    :id="custommetadata._id"
                                    :placeholder="'Select '+custommetadata.name"
                                  >
                                  </date-picker>
                                  <date-picker
                                    :value="getCustomMetadataById(custommetadata._id)"
                                    v-if="custommetadata.type == 'DATE_TIME'"
                                    valueType="format"
                                    type="datetime"
                                    :class="{readOnly:nonEditableFields}"
                                    @change="updateCustomMetadataById(custommetadata, $event)"
                                    class="rounded text-light w-100"
                                    style="margin-inline-start:5px;"
                                    :id="custommetadata._id"
                                    :placeholder="'Select '+custommetadata.name"
                                    confirm
                                  >
                                  </date-picker>
                                  <Multiselect
                                    v-if="custommetadata.type == 'PICKLIST' && singlePicklistTypeCheck(custommetadata)"
                                    :value="getSinglePicklistVal(custommetadata._id)"
                                    :options="custommetadata.values"
                                    :searchable="true"
                                    :preserveSearch="true"
                                    :close-on-select="true"
                                    :id="custommetadata._id"
                                    :ref="custommetadata._id"
                                    :allow-empty="false"
                                    deselectLabel=""
                                    selectLabel=""
                                    selectedLabel=""
                                    track-by="value_id"
                                    label="value"
                                    @select="updateCustomMetadataById(custommetadata,$event)"
                                    placeholder="Select picklist"
                                    style="margin-inline-start:5px;">
                                    <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                    <span style="margin-inline-start:12px;">{{ scope.option.value}}</span>
                                    </div>
                                    <span slot="noResult">No results.</span>
                                  </Multiselect>
                                  <Multiselect
                                      v-if="custommetadata.type == 'PICKLIST_MULTIVALUE' && picklistTypeCheck(custommetadata)"
                                      v-model="picklistData[custommetadata._id]"
                                      :options="custommetadata.values"
                                      :multiple="true"
                                      :id="custommetadata._id"
                                      @input="updateCustomMetadataById(custommetadata,$event)"
                                      @remove="removeSelectedPicklistOption($event,custommetadata)"
                                      :class="{readOnly:nonEditableFields}"
                                      placeholder="Select Picklist"
                                      :close-on-select="true"
                                      :show-no-results="true"
                                      :allow-empty="false"
                                      track-by="value_id"
                                      label="value"
                                      deselectLabel=""
                                      selectLabel=""
                                      selectedLabel=""
                                      style="margin-inline-start:5px !important;">
                                      <span slot="noResult">No results</span>
                                      <span slot="noOptions" style="display:none"></span>
                                      <div slot="tag" slot-scope="option" class="selected-tags-style">
                                      <div class="tags-display-style">{{option.option.value}}</div>
                                          <div class="remove-tag" v-on:click="removeSelectedPicklistOption(option.option,custommetadata)">
                                              <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                              <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                              </svg>
                                          </div>
                                      </div>
                                      <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                      <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makePicklistCheckBoxSelection(scope.option,custommetadata._id)" @focus.prevent :key="scope.option.name"/>
                                      <span style="margin-inline-start:12px;">{{ scope.option.value }}</span>
                                      </div></Multiselect>
                                </div>
                              </div>
                              </div>
                            <div class="aboutField" :title="custommetadata.about_field" v-if="Object.keys(custommetadata).includes('about_field') &&
                            custommetadata.about_field.length" @click="enableOrDisableFieldInfo(custommetadata._id)">
                              <svg xmlns="http://www.w3.org/2000/svg" style="position: relative;inset-inline-start:2px;bottom: 2px;" width="16" height="16" fill="#939393" class="bi bi-question-circle-fill" viewBox="0 0 16 16">
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
                              </svg>
                            </div>
                            </div>
                          </li>
                          <div v-if="isChildExists(custommetadata)" style="margin: 0px 8px 4px 11px;position: relative;width: 95%;padding-bottom: 0px;" >
                            <RecursiveList :HMData="getHierarchyMetadata(custommetadata)" :parentCM="null" :defaultCategory="defaultCategory" :parentData="parentData" :onGoingChanges="assetCustomMetadata" :ismediaEdit="ismediaEdit" :enableOnlyFields="enableOnlyFields" 
                            :screenType="screenType" :enableMediaSlug="enableMediaSlug" :assetsBrowseAccess="assetsBrowseAccess" @updatedCM="handleCMUpdate" />
                          </div> 
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
              <!-- <div class="text-left" style="padding: 10px 0px 10px 8px; color: #777">
                <svg  v-if="!showSystemDefinedMetadata" v-on:click="showSystemDefinedMetadata = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                    <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                </svg>
                <svg v-if="showSystemDefinedMetadata" v-on:click="showSystemDefinedMetadata = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                    <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                </svg>
                  <span style="position:relative;inset-inline-start:1px;top:2px;font-size: 18px;">System Defined Metadata</span>
              </div>
              <template v-if="enableFieldsWithMetadataPriv && showSystemDefinedMetadata">
                <div v-for="eachId in uploadScreenInfo.field_id_list" :key="eachId">
                  <div v-if="displayAlwaysFieldsIdList.includes(eachId) ||  profileDetails.custom_metadata_allId_list ||
                  (profileDetails.custom_metadata_display_config > 0 && fetchedFieldIdList.includes(eachId)) ||
                    selectedRelaventProfileIdList.includes('All')">
                      <div v-for="custommetadata in (customMetadataList.filter((cmdata)=>cmdata._id == eachId))" :key="custommetadata._id">
                        <template v-if="'definition_type' in custommetadata && custommetadata.definition_type == 'system-defined'">
                        <li :id="'field-'+custommetadata._id" :key="custommetadata._id" class="d-block"
                          >
                          <div style="display: flex;position:relative">
                          <div class="upload-fields" :class="{focusField:activeField == custommetadata.name, 
                          readonlyDiv: uploadScreenInfo.read_only_field_id_list.includes(custommetadata._id)}" v-on:click="activeField = custommetadata.name">
                            <div style="display: flex;">
                              <div class="key-style">{{ custommetadata.name }}
                                <span class="readonly-field" v-if="uploadScreenInfo.read_only_field_id_list.includes(custommetadata._id)">
                                ( non editable )
                                </span>
                              </div>
                              <span style="color:#858585" v-if="uploadScreenInfo.mandatory_field_id_list.includes(custommetadata._id)">*</span>
                            </div>
                            <div class="value-style d-inline-flex">
                              <div v-if="uploadScreenInfo.read_only_field_id_list.includes(custommetadata._id)"></div>
                              <div v-else class="w-100">
                                <input
                                  :value="getCustomMetadataById(custommetadata._id)"
                                  type="text"
                                  :class="{readOnly:nonEditableFields}"
                                  @change="updateCustomMetadataById(custommetadata, $event.target.value)"
                                  v-if="custommetadata.type == 'FREETEXT'"
                                  class="rounded input-fields text-light w-100"
                                  style="margin-inline-start:5px;padding: 4px;"
                                  :id="custommetadata._id"
                                />

                                <textarea
                                  :value="getCustomMetadataById(custommetadata._id)"
                                  type="text"
                                  :class="{readOnly:nonEditableFields}"
                                  @change="updateCustomMetadataById(custommetadata, $event.target.value)"
                                  v-if="custommetadata.type == 'FREETEXT_MULTILINE'"
                                  class="rounded text-light w-100"
                                  style="margin-inline-start:5px;max-height:200px;min-height: 100px;padding: 4px;
                                  :1px solid #3a3a3a !important;"
                                  :id="custommetadata._id">
                                </textarea>
                                <input
                                  :value="getCustomMetadataById(custommetadata._id)"
                                  type="number"
                                  :class="{readOnly:nonEditableFields}"
                                  @change="updateCustomMetadataById(custommetadata, $event.target.value)"
                                  v-if="custommetadata.type == 'INTEGER'"
                                  class="rounded input-fields text-light w-100"
                                  style="margin-inline-start:5px;padding: 4px;"
                                  :id="custommetadata._id"
                                />
                                <date-picker
                                  :value="getCustomMetadataById(custommetadata._id)"
                                  v-if="custommetadata.type == 'DATE'"
                                  valueType="format"
                                  :class="{readOnly:nonEditableFields}"
                                  @change="updateCustomMetadataById(custommetadata, $event)"
                                  class="rounded text-light w-100"
                                  style="margin-inline-start:5px;"
                                  :id="custommetadata._id"
                                >
                                </date-picker>
                                <date-picker
                                  :value="getCustomMetadataById(custommetadata._id)"
                                  v-if="custommetadata.type == 'DATE_TIME'"
                                  valueType="format"
                                  type="datetime"
                                  :class="{readOnly:nonEditableFields}"
                                  @change="updateCustomMetadataById(custommetadata, $event)"
                                  class="rounded text-light w-100"
                                  style="margin-inline-start:5px;"
                                  :id="custommetadata._id"
                                  confirm
                                >
                                </date-picker>
                                <Multiselect
                                  v-if="custommetadata.type == 'PICKLIST' && singlePicklistTypeCheck(custommetadata)"
                                  :value="getSinglePicklistVal(custommetadata._id)"
                                  :options="custommetadata.values"
                                  :searchable="true"
                                  :preserveSearch="true"
                                  :close-on-select="true"
                                  :id="custommetadata._id"
                                  :ref="custommetadata._id"
                                  :allow-empty="false"
                                  deselectLabel=""
                                  selectLabel=""
                                  selectedLabel=""
                                  track-by="value_id"
                                  label="value"
                                  @select="updateCustomMetadataById(custommetadata,$event)"
                                  placeholder="Select picklist"
                                  style="margin-inline-start:5px;">
                                  <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                  <span style="margin-inline-start:12px;">{{ scope.option.value}}</span>
                                  </div>
                                  <span slot="noResult">No results.</span>
                                </Multiselect>
                                <Multiselect
                                    v-if="custommetadata.type == 'PICKLIST_MULTIVALUE' && picklistTypeCheck(custommetadata)"
                                    v-model="picklistData[custommetadata._id]"
                                    :options="custommetadata.values"
                                    :multiple="true"
                                    :id="custommetadata._id"
                                    @input="updateCustomMetadataById(custommetadata,$event)"
                                    @remove="removeSelectedPicklistOption($event,custommetadata)"
                                    :class="{readOnly:nonEditableFields}"
                                    placeholder="Select Picklist"
                                    :close-on-select="true"
                                    :show-no-results="true"
                                    :allow-empty="false"
                                    track-by="value_id"
                                    label="value"
                                    deselectLabel=""
                                    selectLabel=""
                                    selectedLabel=""
                                    style="margin-inline-start:5px;">
                                    <span slot="noResult">No results</span>
                                    <span slot="noOptions" style="display:none"></span>
                                    <div slot="tag" slot-scope="option" class="selected-tags-style">
                                    <div class="tags-display-style">{{option.option.value}}</div>
                                        <div class="remove-tag" v-on:click="removeSelectedPicklistOption(option.option,custommetadata)">
                                            <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                            </svg>
                                        </div>
                                    </div>
                                    <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                    <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makePicklistCheckBoxSelection(scope.option,custommetadata._id)" @focus.prevent :key="scope.option.name"/>
                                    <span style="margin-inline-start:12px;">{{ scope.option.value }}</span>
                                    </div></Multiselect>
                              </div>
                            </div>
                            </div>
                          <div class="aboutField" :title="custommetadata.about_field" v-if="Object.keys(custommetadata).includes('about_field') &&
                          custommetadata.about_field.length" @click="enableOrDisableFieldInfo(custommetadata._id)">
                            <svg xmlns="http://www.w3.org/2000/svg" style="position: relative;inset-inline-start:2px;bottom: 2px;" width="16" height="16" fill="#939393" class="bi bi-question-circle-fill" viewBox="0 0 16 16">
                              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
                            </svg>
                          </div>
                          </div>
                        </li>
                      </template>
                      </div>
                  </div>
                </div>
              </template> -->
              <li v-if="hiddenFieldIdList.length > 0 && enableFieldsWithMetadataPriv" class="d-inline-flex" style="    position: relative;
                  bottom: 0px;
                  inset-inline-start:0px;
                  justify-content: start;border:none">
                  <div> + {{hiddenFieldIdList.length}} More fields are hidden.</div>
                  <div>
                      <a href="#!" v-on:click.stop.prevent="handleHiddenFieldsView" style="margin-inline-start: 5px;">Show Fields</a>
                  </div>
              </li>
            </template>
        </ul>
    </div>
</template>

<script>
import highlightMixin from '../../mixins/SequenceMetadataComponentMixin.js';
import DatePicker from "vue2-datepicker";
import Multiselect from 'vue-multiselect';
import MultiCatalogDropdown from "../categories/CatalogMultiselectDropdown.vue";
import TagsDropdown from "../tags/TagsSelectionDropdown.vue";
import RecursiveList from "./SequenceRecursiveList.vue";


export default {
  mixins:[highlightMixin],
  props:["jobInfoFromUploadPanel","defaultCategory","fixMinWidth","parentData","ismediaEdit","enableOnlyFields","screenType","enableMediaSlug", "parentRouteName", "enableLoadMoreFields", "assetsBrowseAccess"],
    data(){
        return{
        };
    },
    components:{
        "date-picker":DatePicker,
        "Multiselect":Multiselect,
        "multi-catalog-dropdown":MultiCatalogDropdown,
        "tags-dropdown":TagsDropdown,
        RecursiveList
    }
}
</script>


<style scoped lang="scss">
  $border-color: 1px solid #4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $input-field-height:38px;
  $highlight-font-color:#ff9800;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $secondary-border-color: 1px solid #2b2b2b;
  $tags-background-color:#282d31;
  $tags-border-color:#363636;
  $input-field-padding:.375rem 10px;
  $readOnly-bg-color: #1e2326 !important;

.modal-dialog {
    width: 100vw;
    height: 100vh;
    max-width:100%;
    margin: 0;
    padding: 0;
  }

  .view-tags{
    font-size: 12px;
    height: 24px;
    display: inline-flex;
    margin:2px !important;
    border: 1px solid $tags-background-color!important;
    border-radius: 15px !important;
    min-width: 50px;
    padding: 0px !important;
    text-align: center;
    width:auto !important;
    div{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 12px;
            border-radius: 15px !important;
            position: relative;
            top: 1px;
    }
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-background-color;
    .modal-body{
      background: $primary-background;
      height:400px;
      overflow:auto;
    }
  }

  .readOnly{
    pointer-events: none;
    border: none !important;
  }

.bigger-checkboxes{
  margin-inline-end: 5px;
}

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.border{
    border: $border-color;
}

.activeclass{
    color: $active-blue;
}

.activeNav,.activeNav:hover{
    background: $primary-background !important;
    color: $active-blue !important;
}
.modal-header,.modal-footer{
    border: none !important;
    background: $secondary-background-color;
    .modal-title{
      color:$text-color;
    }
}

ul{
    list-style-type: none;
}

.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}

.primary-btn-style{
    margin-top:1%;
    height:100px;
    display:inline-flex !important;
    flex-wrap: nowrap !important;
    button{
        height: 35px !important;
        border-radius: 25px;
        width: 70px;
    font-size:14px;
    }
}

.search-bar-comm-style{
  height:30px;
  position:relative;
  input{
    border:$border-color;
    height: 25px;
    padding-inline-start: 3%;
  }
  svg{
    position: absolute;
    inset-inline-start:1px;
    top: 21%;
  }
}

.readonly-field{
  color:$dull-text-color;
  font-size:12px;
}
textarea{
  height:150px !important;
  resize: none;
  overflow: auto;
}

.readonly-field{
  color:$secondary-text-color;
}

.secondary-btn-style{
  color:$text-color;
}

.modal-footer{
    justify-content: start;
}

.view-tags{
    font-size: 12px;
    height: 24px;
    display: inline-flex;
    margin:2px !important;
    border: $border-color !important;
    border-radius: 15px !important;
    min-width: 50px;
    padding: 0px !important;
    text-align: center;
    width:auto !important;
    span{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 12px;
            border-radius: 15px !important;
            position: relative;
            top: 1px;
    }
}

.view-tags:hover{
    border: $border-color !important;
}

.activeTag{
    color: $active-blue !important;
}


.metadata-dock-ul li .aboutField {
  visibility: hidden;
  position: absolute;
}

.metadata-dock-ul li:hover .aboutField {
  visibility: visible;
  position: absolute;
  inset-inline-end: 7px;
  top: 18px;
}


.metadata-dock-ul {
  list-style-type: none;
  padding: 0px 8px;
  user-select: none; 
  position:relative;
  margin-inline-start:0px;
  width:100%;
  height:100%;
  .fields-styles{
      margin-bottom:8px;
    .upload-fields{
      margin-bottom:14px;
    }
  }
  .upload-fields {
    display: inline-flex;
    padding: 7px;
    border-radius: 4px;
    margin: 4px 0px;
    width: 100%;
    position: relative;
    background:$primary-background;
    .key-style {
      color: $dull-text-color;
      max-width: 100%;
      text-align: end;
      font-size: 14px;
      padding-inline-start: 5px;
      padding-inline-end: 5px;
      margin-top: 6px;
      display:inline-flex;
      align-items: flex-start;
    }
    .value-style {
      color: $text-color;
      width: 45%;
      text-align: start;
      padding-top: 3px;
      padding-bottom: 3px;
      padding-inline-end: 5px;
      padding-inline-start: 0px;
      .slug-ellipsis {
        white-space: nowrap;
        max-width: 350px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .save-cancel-icon{
        position:relative;
        top:10px;
        inset-inline-start:5px;
        color:$text-color;
      }
      .browse-icon{
        color:#636363 !important;
      }
    }
  }
}

// .metadata-dock-ul .upload-fields:hover {
//   border: 1px solid $bg-color-on-hover;
// }

// .metadata-dock-ul .upload-fields:focus {
//   border: 1px solid $active-blue !important;
// }

textarea:focus{
  outline: none;
  bottom: 0px;
  inset-inline-start:0px;
  --saf-0: rgba(var(--sk_highlight,18,100,163),1);
  box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
  border-radius: 4px;
  border-color: transparent;
  -webkit-appearance: none;
}

.input-fields,.mx-datepicker, textarea,.multiselect{
    border-radius: 5px !important;
    border:$border-color !important;
    height: 38px !important;
    background: $primary-background;
}

.input-fields:hover,.mx-datepicker:hover, textarea:hover,.multiselect:hover{
    border:1px solid #7a7a7a !important;
}
.input-fields{
    margin-inline-start: 5px;
    padding:$input-field-padding !important;
}

.input-fields:focus{
    outline: unset;
    // border-bottom: 1px solid #0373ee !important;
}

.upload-fields{
    // border: $secondary-border-color !important;
    width: 90%;
    border-radius: 5px;
}

.focusField{
  // border:1px solid #816932;
  input:focus, select:focus{
    border:none !important;
  }
}

.tags-display-ul .show-tags-delete{
  visibility:hidden;
}

.tags-display-ul li:hover .show-tags-delete{
  visibility: visible;
}

.show-tags-delete{
  position: relative;
  top: 2px;
}

::v-deep{
.mx-input{
    background: $primary-background !important;
    border: none !important;
    color: #eee !important;
    height: 34px;
}
.mx-datepicker-main{
    border: $border-color !important;
    background: $secondary-background-color !important;
}
.mx-calendar-content .cell:hover{
    background-color: $bg-color-on-hover !important;
}
.mx-datepicker-range{
  width:100%
}
.mx-calendar-content .cell:hover {
    color: #000000;
    background-color: #7d99b1;
}
.mx-icon-calendar{
  color:$dull-text-color;
}

.secondary-btn-style:hover{
  text-decoration: underline;
}

.close-icon:hover{
  background: $bg-color-on-hover;
  border-radius: 20px;
}

}

::v-deep{

  .readonlyDiv{
      background: $readOnly-bg-color;
      pointer-events: none;
      border:none !important;
      .multiselect__tags{
        border: none !important;
      }
  }
  .multiselect {
    margin: 3px 0px;
  }
  .multiselect__content-wrapper {
    display: none;
  }
  .multiselect__tag, .tags-style {
    background-color: $primary-background !important;
    border: $border-color;
    border-radius: 5px;
  }
  .multiselect__tags, .tags-style {
    background: transparent !important;
    border:none;
    // --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    // box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    // border-radius: 4px;
    // border-color: transparent;
    // -webkit-appearance: none;
  }
  .multiselect__option--highlight {
    background: $bg-color-on-hover !important;
  }
  .multiselect__content {
    background: $secondary-background-color !important;
  }
  .multiselect__input,
  .multiselect__single {
    background: transparent !important;
    color: $text-color;
    word-break: break-all;
  }
  .multiselect__single{
    padding-inline-start: 9px !important;
    margin-top: 0px !important;
    padding-top: 6px !important;
  }
  .multiselect__input{
      padding-top:0px !important;
  }

  .multiselect__tag-icon {
    color: $text-color !important;
  }
  .multiselect__tag-icon:focus,
  .multiselect__tag-icon:hover {
    background: $bg-color-on-hover !important;
    color: $text-color !important;
  }
  .multiselect__tag-icon:after {
    color: $secondary-text-color !important;
    font-size: 23px;
  }

  .multiselect__tag-icon {
    visibility: hidden;
  }

  .multiselect__tag:hover .multiselect__tag-icon {
    visibility: visible;
  }
  .multiselect__tags:focus, .multiselect__input:focus{
    outline: none;
    height: 38px;
    bottom: 0px;
    inset-inline-start:0px;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
    }

  .multiselect * {
    font-size: $input-field-and-label-font-size;
    font-family: "Roboto", Arial, sans-serif !important;
  }
  .multiselect__placeholder {
    padding-top: 8px !important;
    padding-inline-start:8px !important;
  }
  .multiselect {
    color: $text-color !important;
    font-size: $input-field-and-label-font-size !important;
    width: 100% !important;
    min-height: 38px !important;
    height:auto !important;
  }
  .multiselect__option--selected {
    background: $bg-color-on-hover !important;
    color: $text-color;
  }
  .multiselect__content-wrapper {
    border: 1px solid $bg-color-on-hover !important;
    position: absolute !important;
    display: block;
    background: $text-color !important;
    width: 100% !important;
    max-height: 240px !important;
    overflow: auto !important;
    border: 1px solid $text-color !important;
    border-top: none !important;
    border-bottom-left-radius: 5px !important;
    border-bottom-right-radius: 5px !important;
    z-index: 50 !important;
    -webkit-overflow-scrolling: touch !important;
  }

  .multiselect__current,
  .multiselect__option {
    line-height: 12px !important;
  }

  .multiselect--above .multiselect__content-wrapper {
    background: $secondary-background-color !important;
  }
  .multiselect__tags {
    padding: 0px 0px 0px 0px;
    min-height: 40px !important;
    //border: $border-color !important;
    border-radius: 5px !important;
  }
}

.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}
input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}

.selected-tags-style{
  background: $tags-background-color !important;
  border: 1px solid $tags-border-color;
  border-radius: 15px;
  font-size: 12px !important;
  min-height: 30px !important;
  display: inline-flex !important;
  margin: 2px !important;
  border-radius: 15px !important;
  min-width: 50px !important;
  padding: 0px !important;
  text-align: center;
  width: auto !important;
  padding-inline-start: 12px !important;
  justify-content: center;
  padding-top: 4px !important;
  padding-inline-end: 4px !important;
  .remove-tag{
    line-height:18px;
  }
}

.tags-display-ul{
  margin-inline-start:0px;
    list-style-type: none;
    display: inline-flex;
    flex-wrap: wrap;
    margin-top: 0;
    width: 100%;
    justify-content: start;
    overflow: auto;
  label{
    padding: 0px 5px;
  }
}
</style>
